export default __webpack_public_path__ + "static/media/gold.c5b5ed5f.png";